import { VesselReservationType } from '../graphql';
import startCase from 'lodash/startCase';
import capitalize from 'lodash/capitalize';

export const vesselReservationTypes = Object.keys(VesselReservationType).map(
  (val) => ({
    id: val,
    label: capitalize(startCase(val)),
  }),
);
